// IMPORTANT NOTE:
// These files are also present in FEA until blu_constants is rolled out
// if you change anything here, you need to change it there as well.

import FullLicense from "./full";
import SelfServiceLicense from "./self_service";
import m365 from "./m365";
import cloud from "./cloud";

export default {
  FREE: SelfServiceLicense,
  M365: m365,
  CLOUD: cloud,
  ADVANCED: FullLicense,
};
